import { useEffect, useState } from 'react';

interface UseUncategorizedPipelinesStateProps {
  initialPage?: number;
  cleanup?: () => void;
}

interface UseUncategorizedPipelinesStateReturn {
  expanded: boolean;
  setExpanded: (expanded: boolean) => void;
  scaleFactor: number;
  setScaleFactor: (scaleFactor: number) => void;
  selectedDataSource: number | null;
  setSelectedDataSource: (selectedDataSource: number | null) => void;
  cloneSelectedFlow: any;
  setCloneSelectedFlow: (cloneSelectedFlow: any) => void;
  currentPage: number;
  setCurrentPage: (currentPage: number) => void;
  sortCriteria: string;
  setSortCriteria: (sortCriteria: string) => void;
}

export function useUncategorizedPipelinesState(
  props: UseUncategorizedPipelinesStateProps,
): UseUncategorizedPipelinesStateReturn {
  const { initialPage = 1, cleanup = () => {} } = props;

  const [expanded, setExpanded] = useState(false);
  const [scaleFactor, setScaleFactor] = useState(1);
  const [selectedDataSource, setSelectedDataSource] = useState(null);
  const [cloneSelectedFlow, setCloneSelectedFlow] = useState<any>(null);
  const [currentPage, setCurrentPage] = useState(initialPage);
  const [sortCriteria, setSortCriteria] = useState<string>('LAST_CREATED_DESC');

  useEffect(() => {
    return () => cleanup();
  }, []);

  return {
    expanded,
    setExpanded,
    scaleFactor,
    setScaleFactor,
    selectedDataSource,
    setSelectedDataSource,
    cloneSelectedFlow,
    setCloneSelectedFlow,
    currentPage,
    setCurrentPage,
    sortCriteria,
    setSortCriteria,
  };
}
